import { render, staticRenderFns } from "./HomeViewItem.vue?vue&type=template&id=584a58bb&scoped=true"
import script from "./HomeViewItem.vue?vue&type=script&lang=js"
export * from "./HomeViewItem.vue?vue&type=script&lang=js"
import style0 from "./HomeViewItem.vue?vue&type=style&index=0&id=584a58bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a58bb",
  null
  
)

export default component.exports